import React from 'react';
import { createContext, useContext } from 'react';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from 'lodash';

import { axios } from '../../../utils/axios';
import { success, successAPI, errorAPI, getMaxPageSize, isNumeric } from '../../../utils/utils';
import Yup from '../../../utils/yup';
// import {  } from '../../../utils/enums';


export const fields = {
  name: {
    id: 'name',
    label: 'Name',
    placeholder: ' ',
  },
};


export const formSchema = (id: number|null= null) => {
  return Yup.object().shape({
    name: Yup.string().required().label(fields.name.label),
  })
}


let formikContext: any = null;
export const FormikContext = createContext<any>(null);
export const useFormikContext = () => {
    formikContext = useContext(FormikContext);
    if (!formikContext) {
      throw new Error('useFormikContext must be used within a FormikProvider');
    }
    return formikContext;
};


export const prepareForm = (values: any = null, defValues: any = null, idField: string, nameField: string) => {
  let form = _.cloneDeep(values);
  let data = _.cloneDeep(defValues);
  
  if(data && form){
    let id = (isNumeric(form[idField])) ? form[idField] : 0;
    let name = (form[nameField] && form[nameField] !== '') ? form[nameField] : '';

    data['id'] = id;
    data['name'] = name;
  }
  
  return data;
};
export const prepareData = (values: any = null, id: any = null, idField: string, nameField: string) => {
  let data: any = {};

  let form = _.cloneDeep(values);

  if(form){
    data[nameField] = form.name;

    if(id){
      data[idField] = id;
    }
  }

  return data;
};


export interface initialValuesStruct {
  id: number|null,
  name: string,
};
export const initialValues: initialValuesStruct = {
  id: null,
  name: '',
};


interface InitState {
  isLoading: boolean,
  show: boolean,
  index: number|null,
  id: number|null,
  details: any,

  title: string,
  path: string,
  idField: string,
  nameField: string,
}


function NewReducer() {
  const name = 'modalCreateItemSlice';


  const initialState: InitState = {
    isLoading: false,
    show: false,
    index: null,
    id: null,
    details: initialValues,

    title: '',
    path: '',
    idField: '',
    nameField: '',
  };


  const reducers = {
    resetSlice: () => {
      return initialState;
    },
    setLoading: (state: InitState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setValues: (state: InitState, action: PayloadAction<any>) => {
      state.details = action.payload;
    },
    

    setShow: (state: InitState, action: PayloadAction<{ show: boolean, index: number|null, id: number|null, title: string, path: string, idField: string, nameField: string }>) => {
      state.isLoading = false;
      state.id = action.payload.id;
      state.index = action.payload.index;
      state.title = action.payload.title;
      state.path = action.payload.path;
      state.idField = action.payload.idField;
      state.nameField = action.payload.nameField;
      state.show = action.payload.show;
    },
    

    startDetails: (state: InitState) => {
      state.isLoading = true;
    },
    finishDetails: (state: InitState, action: PayloadAction<any>) => {
      state.details = action.payload;
      state.isLoading = false;
    },
    
    startCreate: (state: InitState) => {
      state.isLoading = true;
    },
    finishCreate: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },

    startUpdate: (state: InitState) => {
      state.isLoading = true;
    },
    finishUpdate: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },

    startDelete: (state: InitState) => {
      state.isLoading = true;
    },
    finishDelete: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },
  };


  const apis = {
    callDetailsApi: (path: string, id: number|null, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startDetails());

      await axios.get(path + id).then((result: any) => {
        let data = result.data;

        // successAPI(data);

        callback(true, data);
        dispatch(actions.finishDetails(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishDetails(null));
      });
    },

    callCreateApi: (path: string, params: any, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startCreate());

      await axios.post(path, params).then((result: any) => {
        let data = result.data;
        
        // successAPI(data);
        // success('Saved successfully', 'The data you entered has been successfully saved.');

        callback(true, data);
        dispatch(actions.finishCreate(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishCreate(null));
      });
    },

    callUpdateApi: (path: string, params: any, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startUpdate());

      await axios.put(path, params).then((result: any) => {
        let data = result.data;
        
        // successAPI(data);
        // success('Updated successfully', 'Your data has been successfully updated.');

        callback(true, data);
        dispatch(actions.finishUpdate(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishUpdate(null));
      });
    },

    callDeleteApi: (path: string, params: any, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startDelete());

      await axios.delete(path, { data: params }).then((result: any) => {
        let data = result.data;
            
        // successAPI(data);
        success('Deleted successfully', 'Item has been successfully deleted.');

        callback(true, data);
        dispatch(actions.finishDelete(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishDelete(null));
      });
    },
  };


  const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers,
  });


  return {
    reducer,
    ...actions,
    ...apis,
  };
}


export default NewReducer();